import React from 'react'

const Bell = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1082 22.308C11.931 23.4696 12.7233 24.276 13.6934 24.6778C17.4123 26.2185 22.5876 26.2185 26.3066 24.6778C27.2766 24.276 28.0689 23.4696 27.8917 22.308C27.7828 21.594 27.2443 20.9995 26.8453 20.419C26.3227 19.6494 26.2708 18.8098 26.2707 17.9166C26.2707 14.4648 23.4632 11.6666 20 11.6666C16.5368 11.6666 13.7293 14.4648 13.7293 17.9166C13.7292 18.8098 13.6772 19.6494 13.1547 20.419C12.7557 20.9995 12.2172 21.594 12.1082 22.308Z" stroke="#2F3237" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16.6666 25.833C17.0487 27.2707 18.3962 28.333 20 28.333C21.6037 28.333 22.9512 27.2707 23.3333 25.833" stroke="#2F3237" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
  )
}

export default Bell
